import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { ReportEffects } from './report.effects';
import { reportReducer } from './report.reducer';

/**
 * Standalone providers for the `reportConfig` NgRx feature slice (SEOMS-437).
 * Replaces the former `ReportStoreModule`.
 */
export function provideReportsStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState('reportConfig', reportReducer),
    provideEffects([ReportEffects]),
  ]);
}
